import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=734aaf78&"
import script from "./TableHead.vue?vue&type=script&lang=js&"
export * from "./TableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734aaf78')) {
      api.createRecord('734aaf78', component.options)
    } else {
      api.reload('734aaf78', component.options)
    }
    module.hot.accept("./TableHead.vue?vue&type=template&id=734aaf78&", function () {
      api.rerender('734aaf78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/TableHead.vue"
export default component.exports